import { FC } from 'react';

import Button from '~components/generic/elements/Button';

export interface ICodePenButtonProps {
  link: string;
}

const CodePenButton: FC<ICodePenButtonProps> = ({ link }) => {
  if (typeof link !== 'string') {
    return null;
  }

  return (
    <Button
      className="u-size-xs c-button c-button--light u-margin-left-md u-padding-horizontal-md"
      name="ui-component-codepen"
      label="Try it on CodePen"
      title="Try it on CodePen"
      href={link}
      rel="noopener noreferrer"
      target="_blank"
      hideLabel={true}
      iconName="codepen"
      iconCentered={false}
    />
  );
};

export default CodePenButton;
